/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/


import {FETCH_BINARIES_DETAILS_REQUEST, FETCH_BINARIES_DETAILS_SUCCESS, FETCH_BINARIES_DETAILS_FAILURE, UPLOAD_PROGRESS} from './AddNewApkFileCreateReleaseTypes';
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";
import APIManager from '../../ApiManager/ApiManager';

export const fetchBinaryDetailsRequest = () => {
    return {
      type: FETCH_BINARIES_DETAILS_REQUEST,
    };
  };
  
  export const fetchBinaryDetailsSuccess = (appData) => {
    return {
      type: FETCH_BINARIES_DETAILS_SUCCESS,
      payload: appData,
    };
  };
  
  export const fetchBinaryDetailsFailure = (error) => {
    return {
      type: FETCH_BINARIES_DETAILS_FAILURE,
      payload: error,
    };
  };

  export const updateUploadProgress = (progress) => {
    return {
      type: UPLOAD_PROGRESS,
      payload: progress,
    };
  };
  
  export const fetchBinaryDetails = (applicationId, submissionId, file) => {
    return async function (dispatch) {
      dispatch(fetchBinaryDetailsRequest());
      try {
        console.log("Starting file upload for applicationId:", applicationId, "submissionId:", submissionId, "file:", file);
        const data = await APIManager.uploadBinaryFile(applicationId, submissionId, file, (progress) => {
          dispatch(updateUploadProgress(progress));
        });
        dispatch(fetchBinaryDetailsSuccess(data));
      } catch (error) {
        dispatch(fetchBinaryDetailsFailure(error));
        dispatch(commonError(error, FETCH_BINARIES_DETAILS_FAILURE));
      }
    };
  };

  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }
